import { getCurrentInstance as e } from "vue";
const o = Object.assign;
function c(t) {
  const n = e();
  n && o(n.proxy, t);
}
export {
  o as extend,
  c as useExpose
};
